import { render, staticRenderFns } from "./amortizationSetting.vue?vue&type=template&id=8190b54c&scoped=true&"
import script from "./amortizationSetting.vue?vue&type=script&lang=js&"
export * from "./amortizationSetting.vue?vue&type=script&lang=js&"
import style0 from "./amortizationSetting.vue?vue&type=style&index=0&id=8190b54c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8190b54c",
  null
  
)

export default component.exports